<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-24T11:44:01+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe: List brand images
@Last modified by:   tom
@Last modified time: 2018-01-03T13:21:52+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">
  <section id="clients" class="container">
    <div class="header">
      <icon class="text-secondary" name="wrench" scale="2" />
      <h1 class="text-secondary">
        {{ $t('clients.title') }}
      </h1>
      <span v-html="$t('clients.payload')" />
    </div>

    <!-- list all clients -->
    <b-container id="clientlist">
      <b-row align-v="center" class="mt-4">
        <b-col v-for="i in 2" :key="i" lg>
          <b-row align-v="center" class="mt-4">
            <b-col v-for="j in 2" :key="j" md>
              <b-row>
                <b-col v-for="f in 4" :key="f" class="pl-2 pr-2">
                  <lzimg
                    v-if="$te('clients.seals.' + (((i-1)*2 + (j-1))*4 + f))"
                    :src="assetUrl('img/seals/'+ $t('clients.seals.' + (((i-1)*2 + (j-1))*4 + f)))"
                    fluid
                    zoom-modal
                    width="80"
                    height="80"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>

  #brandlist {
    margin-top: 23px;
    height: 70px; // avoid lazy load artifacts on page
  }

</style>
